import React from 'react';
import { Heart, Users, Briefcase, Home, UserX, Sparkles, Lock, MessageSquare } from 'lucide-react';
export type AnalysisMode = 'default' | 'relationships' | 'ex' | 'friends' | 'family' | 'workplace' | 'romantic';
interface ModeOption {
  value: AnalysisMode;
  label: string;
  icon: React.ReactNode;
  isPremium: boolean;
}
const modeOptions: ModeOption[] = [{
  value: 'default',
  label: 'General',
  icon: <MessageSquare size={14} data-id="element-1437" />,
  isPremium: false
}, {
  value: 'relationships',
  label: 'Dating',
  icon: <Heart size={14} data-id="element-1438" />,
  isPremium: true
}, {
  value: 'romantic',
  label: 'Romantic',
  icon: <Sparkles size={14} data-id="element-1439" />,
  isPremium: true
}, {
  value: 'ex',
  label: 'Ex-Partner',
  icon: <UserX size={14} data-id="element-1440" />,
  isPremium: true
}, {
  value: 'friends',
  label: 'Friends',
  icon: <Users size={14} data-id="element-1441" />,
  isPremium: true
}, {
  value: 'family',
  label: 'Family',
  icon: <Home size={14} data-id="element-1442" />,
  isPremium: true
}, {
  value: 'workplace',
  label: 'Workplace',
  icon: <Briefcase size={14} data-id="element-1443" />,
  isPremium: true
}];
interface ModePreviewProps {
  planType: 'free' | 'pay-per-scan' | 'pro';
  selectedMode?: AnalysisMode;
  compact?: boolean;
  light?: boolean;
}
export function ModePreview({
  planType,
  selectedMode = 'default',
  compact = false,
  light = false
}: ModePreviewProps) {
  const isUnlocked = (option: ModeOption) => {
    if (!option.isPremium) return true;
    return planType === 'pay-per-scan' || planType === 'pro';
  };
  const premiumModes = modeOptions.filter(m => m.isPremium);
  return <div className={compact ? 'space-y-2' : 'space-y-3'} data-id="element-1444">
      {/* Mode Grid */}
      <div className="flex flex-wrap gap-2" data-id="element-1445">
        {modeOptions.map(option => {
        const unlocked = isUnlocked(option);
        const isSelected = selectedMode === option.value;
        return <div key={option.value} className={`
                inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-all
                ${isSelected ? light ? 'bg-white/30 text-white border border-white/40' : 'bg-red-100 text-red-700 border border-red-200' : unlocked ? light ? 'bg-white/10 text-white/90 border border-white/20' : 'bg-gray-100 text-gray-700 border border-gray-200' : light ? 'bg-white/5 text-white/50 border border-white/10' : 'bg-gray-50 text-gray-400 border border-gray-200'}
              `} data-id="element-1446">
              <span className={unlocked ? '' : 'opacity-50'} data-id="element-1447">
                {option.icon}
              </span>
              <span data-id="element-1448">{option.label}</span>
              {!unlocked && <Lock size={10} className="opacity-50" data-id="element-1449" />}
            </div>;
      })}
      </div>

      {/* Explanation Text */}
      {planType === 'free' && <p className={`text-xs ${light ? 'text-white/70' : 'text-gray-600'} leading-relaxed`} data-id="element-1450">
          Upgrade to unlock {premiumModes.length} advanced analysis modes for
          specialized relationship contexts
        </p>}
    </div>;
}